import React, { useState } from "react";
import { IKImage } from "imagekitio-react";

import { MediaResponse } from "src/types/experiences/storyboardSettings/primitives";
import Card from "../card";
import { useDraft } from "../useDraft";
import { canEdit } from "src/pages/experiences/storyboardSettings/utils/permissions";
import { isAbsoluteUrl } from "src/pages/experiences/utils/cleverstorySitesettings";
import { EditSocialImage } from "./editBanner";
import styles from "./socialImageCard.module.scss";

const SocialImageCard: React.FC = () => {
  const { draft, setField } = useDraft();
  const social = draft?.social;
  const editable = canEdit(draft?.role);
  const [isEditOpen, setIsEditOpen] = useState(false);

  const handleClose = (value: MediaResponse | null, position: string) => {
    setIsEditOpen(false);
    if (value) {
      setField("social", { ...value, position } as MediaResponse);
    }
  };

  return (
    <Card
      title="General social image"
      description="This image will be shared on social networks including Facebook and Twitter. It’s a great way to help visitors recognize your brand"
    >
      <div className={styles.imageContainer}>
        {social?.url ? (
          <>
            {isAbsoluteUrl(social.url) ? (
              <img
                src={social.url}
                alt="social preview"
                style={{ objectPosition: (social as any)?.position || "center center" }}
              />
            ) : (
              <IKImage
                path={social.url}
                alt="social preview"
                style={{ objectPosition: (social as any)?.position || "center center" }}
              />
            )}
            <div className={styles.actions}>
              <button
                type="button"
                className={styles.actionBtn}
                aria-label="Edit social image"
                disabled={!editable}
                onClick={() => setIsEditOpen(true)}
              >
                <i className="paperflite-edit" />
              </button>
              <button
                type="button"
                className={styles.actionBtn}
                aria-label="Delete social image"
                disabled={!editable}
                onClick={() => setField("social", null as any)}
              >
                <i className="paperflite-delete" />
              </button>
            </div>
          </>
        ) : (
          <button
            type="button"
            className={styles.uploadPlaceholder}
            disabled={!editable}
            onClick={() => setIsEditOpen(true)}
          >
            <i className="paperflite-upload" />
            <span>upload image</span>
          </button>
        )}
      </div>

      {isEditOpen && (
        <EditSocialImage
          image={social}
          position={(social as any)?.position}
          isOpen={isEditOpen}
          onClose={handleClose}
        />
      )}
    </Card>
  );
};

export default SocialImageCard;
